<template>
  <main class=" w-100">
    <div class="containerimg" style="height: 95vh;">
      <img loading="lazy" src="@/assets/images/produklanding.jpeg" alt="Snow"
        style="width:100%;height: 100%;object-fit: cover;">
      <div class="center-center text-center">
        <h2 class="text-white text-uppercase">{{ $t('Product') }}</h2>
        <p class="lead">
          {{ $t('Productlanding_P') }}
        </p>

      </div>
    </div>
  </main>

  <section class="p-5 mb-5 pb-0 bg-darkgrey d-flex align-items-center justify-content-center">
    <div class="container">
      <div class=" text-align-left ">
        <div class="row">
          <div class="col-sm  d-flex align-items-center justify-content-center p-5">
            <div>
              <div class="d-flex align-items-center mb-2">
                <i class="fas fa-circle me-2 text-lightblues "></i>
                <img loading="lazy" style="width:150px;object-fit: cover" src="@/assets/images/logo-uiux.png" alt="">
              </div>
              <p class="text-light" style="text-align: justify;
  text-justify: inter-word;">{{ $t('Prod1_P') }}</p>
            </div>
          </div>
          <div class="col-sm d-flex justify-content-end">
            <img loading="lazy" src="@/assets/images/prod1.jpeg" alt="Snow"
              style="width:100%;height: 100%;object-fit: contain;">
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="p-5 pt-0 pb-0 bg-darkgrey d-flex align-items-center justify-content-center">
    <div class="container">
      <div class=" text-align-left ">
        <div class="row">
          <div class="col-sm d-flex justify-content-end">
            <img loading="lazy" src="@/assets/images/prod2.jpeg" alt="Snow"
              style="width:100%;height: 100%;object-fit: contain;">
          </div>
          <div class="col-sm  d-flex align-items-center justify-content-center p-5">
            <div>
              <div class="d-flex align-items-center mb-2">
                <i class="fas fa-circle me-2 text-lightblues "></i>
                <img loading="lazy" style="width:150px;object-fit: cover" src="@/assets/images/logo-webdev.png" alt="">
              </div>
              <p class="text-light" style="text-align: justify;
  text-justify: inter-word;">{{ $t('Prod2_P') }}</p>
            </div>
          </div>

        </div>
      </div>
    </div>
  </section>

  <section class="p-5 mb-5 pt-0 pb-0 bg-darkgrey d-flex align-items-center justify-content-center">
    <div class="container">
      <div class=" text-align-left ">
        <div class="row">
          <div class="col-sm  d-flex align-items-center justify-content-center p-5">
            <div>
              <div class="d-flex align-items-center mb-2">
                <i class="fas fa-circle me-2 text-lightblues "></i>
                <img loading="lazy" style="width:150px;object-fit: cover" src="@/assets/images/logo-appdev.png" alt="">
              </div>
              <p class="text-light" style="text-align: justify;
  text-justify: inter-word;">{{ $t('Prod3_P') }}</p>
            </div>
          </div>
          <div class="col-sm d-flex justify-content-end">
            <img loading="lazy" src="@/assets/images/prod3.jpeg" alt="Snow"
              style="width:100%;height: 100%;object-fit: contain;">
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="p-5 pt-0 pb-0 bg-darkgrey d-flex align-items-center justify-content-center">
    <div class="container">
      <div class=" text-align-left ">
        <div class="row">
          <div class="col-sm d-flex justify-content-end">
            <img loading="lazy" src="@/assets/images/prod4.jpeg" alt="Snow"
              style="width:100%;height: 100%;object-fit: contain;">
          </div>
          <div class="col-sm  d-flex align-items-center justify-content-center p-5">
            <div>
              <div class="d-flex align-items-center mb-2">
                <i class="fas fa-circle me-2 text-lightblues "></i>
                <img loading="lazy" style="width:150px;object-fit: cover" src="@/assets/images/logo-svm.png" alt="">
              </div>
              <p class="text-light" style="text-align: justify;
  text-justify: inter-word;">{{ $t('Prod4_P') }}</p>
            </div>
          </div>

        </div>
      </div>
    </div>
  </section>

  <section class="p-5 mb-5 pt-0 pb-0 bg-darkgrey d-flex align-items-center justify-content-center">
    <div class="container">
      <div class=" text-align-left ">
        <div class="row">
          <div class="col-sm  d-flex align-items-center justify-content-center p-5">
            <div>
              <div class="d-flex align-items-center mb-2">
                <i class="fas fa-circle me-2 text-lightblues "></i>
                <img loading="lazy" style="width:150px;object-fit: cover" src="@/assets/images/logo-netman.png" alt="">
              </div>
              <p class="text-light" style="text-align: justify;
  text-justify: inter-word;">{{ $t('Prod5_P') }}</p>
            </div>
          </div>
          <div class="col-sm d-flex justify-content-end">
            <img loading="lazy" src="@/assets/images/prod5.jpeg" alt="Snow"
              style="width:100%;height: 100%;object-fit: contain;">
          </div>
        </div>
      </div>
    </div>
  </section>




</template>